import { render, staticRenderFns } from "./HeaderCompactGameCard.vue?vue&type=template&id=a9440d76"
import script from "./HeaderCompactGameCard.vue?vue&type=script&lang=js"
export * from "./HeaderCompactGameCard.vue?vue&type=script&lang=js"
import style0 from "./HeaderCompactGameCard.vue?vue&type=style&index=0&id=a9440d76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports